import {Country} from '~shared/models';
import {IActionButton} from '~shared/modules/addresses/models/action-button.model';
import {IAddress, IAddressDB} from '~shared/modules/addresses/models/address.model';
import {
  ADVANCED_FORM_CONFIG as ENTREPRENEUR_ADVANCED_FORM_CONFIG
} from '~shared/modules/addresses/constants/entrepreneur-address.constant';
import {
  ADVANCED_FORM_CONFIG as CONSUMER_ADVANCED_FORM_CONFIG
} from '~shared/modules/addresses/constants/consumer-address.constant';
import {IAddressData} from '../models/address-data.model';
import {ADDRESS_MANAGEMENT_PAGE_ALIAS_LIST} from '../constants/address-book.constant';
import {ADDRESS_ACTION_LIST, ADDRESS_ACTION_TYPE} from '../constants/address-actions.constant';

export namespace AddressBookUtil {
  export function isChildPage(pageAlias: string): boolean {
    return ADDRESS_MANAGEMENT_PAGE_ALIAS_LIST.includes(pageAlias);
  }

  export function populateAddress(dbAddress: IAddressDB, countries: Country[]): IAddress {
    const country = countries.find(( { id }) => id === dbAddress.country);
    return {
      ...dbAddress,
      countryName: country && country.name,
    };
  }

  export function createAdvancedFormConfig(isEntrepreneur: boolean, addresses: IAddressDB[], countries: Country[]) {
    const isFirstAddress = addresses.length === 0;
    const defaultCountry = countries.find(country => country.default);
    const countryOptions = countries.map(({ id, name }) => ({ label: name, value: id }));
    const advancedFormConfig = isEntrepreneur ? ENTREPRENEUR_ADVANCED_FORM_CONFIG : CONSUMER_ADVANCED_FORM_CONFIG;

    return {
      ...advancedFormConfig,
      initialFormData: {
        country: defaultCountry && defaultCountry.id,
        defaultShipping: isFirstAddress,
        defaultBilling: isFirstAddress,
      },
      fieldsExtraOptions: {
        country: {options: countryOptions},
        defaultShipping: {isDisabled: isFirstAddress},
        defaultBilling: {isDisabled: isFirstAddress},
      },
    };
  }

  export function createAddressData(address: IAddress): IAddressData {
    const actionList = ADDRESS_ACTION_LIST.map((action: IActionButton) => {
      switch (action.type) {
        case ADDRESS_ACTION_TYPE.setDefaultShipping:
          return {
            ...action,
            isDisabled: address.defaultShipping,
          };

        case ADDRESS_ACTION_TYPE.setDefaultBilling:
          return {
            ...action,
            isDisabled: address.defaultBilling,
          };

        default:
          return action;
      }
    });

    return {
      address,
      actionList,
    };
  }
}
